document.addEventListener("DOMContentLoaded", () => {
  const purchases = document.querySelectorAll("[data-collection-purchase]");

  purchases.forEach((purchase) => {
    const minus = purchase.querySelector("[data-quantity-minus]");
    const plus = purchase.querySelector("[data-quantity-plus]");
    const input = purchase.querySelector("[data-quantity-input]");
    const addButton = purchase.querySelector("[data-collection-add]");

    if (!minus || !plus || !input || !addButton) return;

    const getQuantity = () => {
      const value = Number(input.value);
      const max = Number(input.max) || 99;

      if (!Number.isFinite(value)) return 1;

      return Math.max(1, Math.min(max, Math.floor(value)));
    };

    minus.addEventListener("click", () => {
      input.value = Math.max(1, getQuantity() - 1);
    });

    plus.addEventListener("click", () => {
      input.value = Math.min(99, getQuantity() + 1);
    });

    input.addEventListener("change", () => {
      input.value = getQuantity();
    });

    addButton.addEventListener("click", async () => {
      if (addButton.disabled) return;

      const variantId = Number(addButton.dataset.variantId);
      const quantity = getQuantity();

      if (!variantId) return;

      const originalHTML = addButton.innerHTML;

      addButton.disabled = true;
      addButton.classList.add("is-loading");
      addButton.textContent = "Adding...";

      try {
        const root = window.Shopify?.routes?.root || "/";

        const response = await fetch(`${root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity,
              },
            ],
          }),
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description || data.message || "Could not add product to cart",
          );
        }

        addButton.textContent = "Added!";

        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: {
              source: "collection",
              quantity,
            },
          }),
        );

        // El Drawer se abrirá desde cart-drawer.js
        // una vez que haya actualizado su contenido.
      } catch (error) {
        console.error("Add to cart error:", error);
        addButton.textContent = "Try again";
        alert(error.message);
      } finally {
        window.setTimeout(() => {
          addButton.innerHTML = originalHTML;
          addButton.disabled = false;
          addButton.classList.remove("is-loading");
        }, 900);
      }
    });
  });
});
